<template>
  <div>
    <b-modal ref="game-result-details-modal"
             :title="$t('active_tournament_game.modal.title')"
             ok-only
             :ok-title="$t('btn.close')"
             size="lg"
    >
      <div>
        <div v-if="isLoading" class="text-center">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <b-table v-if="!isLoading" striped hover :items="playerCollection" :fields="fields">
          <template #cell(id)="data">
            {{ data.item.id.split('-')[0] }}
          </template>
        </b-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      sortBy: 'finalClassificationPlace',
      sortDesc: false,
      fields: [
        { key: 'id', label: this.$t('table.header.id'), sortable: false },
        { key: 'nickName', label: this.$t('table.header.nick_name'), sortable: false },
        { key: 'finalClassificationPlace', label: this.$t('table.header.final_place'), sortable: false },
        { key: 'award', label: this.$t('table.header.award'), sortable: false }
      ],
      isLoading: true,
      playerCollection: null
    };
  },
  methods: {
    showDetails(data) {
      this.isLoading = true;
      this.getData(data.gameId);
      this.$refs['game-result-details-modal'].show();
    },
    getData(gameId) {
      return axios.get(`/api/game/${gameId}/game-history-item-details`).then(response => {
        this.playerCollection = response.data.players;
        this.isLoading = false;
      });
    }
  }
}
</script>
